import { render, staticRenderFns } from "./spaces-explainer-mobile.vue?vue&type=template&id=a24e2416&scoped=true&"
import script from "./spaces-explainer-mobile.vue?vue&type=script&lang=js&"
export * from "./spaces-explainer-mobile.vue?vue&type=script&lang=js&"
import style0 from "./spaces-explainer-mobile.vue?vue&type=style&index=0&id=a24e2416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24e2416",
  null
  
)

export default component.exports